function PendingApprovalPageContent() {
  return <div>PendingApprovalPageContent</div>
}

export { PendingApprovalPageContent }
